const keys = ['ArrowLeft', 'ArrowRight', 'Home', 'End'];

function targetIndex(key, index, count) {
    if (key === 'ArrowRight') {
        return (index + 1) % count;
    }
    if (key === 'ArrowLeft') {
        return (index - 1 + count) % count;
    }
    return key === 'Home' ? 0 : count - 1;
}

export function rovingTabs(tabs, onSelect) {
    tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => {
            onSelect(index);
        });
        tab.addEventListener('keydown', (event) => {
            if (!keys.includes(event.key)) {
                return;
            }
            event.preventDefault();
            event.stopPropagation();
            const next = targetIndex(event.key, index, tabs.length);
            tabs[next].focus();
            onSelect(next);
        });
    });
}
